document.addEventListener('DOMContentLoaded', function(){
  const defaultMenu = document.querySelector('[data-link-index="default"]');
  const mobileSubmenus = document.querySelectorAll('.menu__childrens');

  window.addEventListener('hashchange', () => {    
    if (window.location.hash === '#menu') {
        document.body.classList.add('index--with-menu');
    } else {
        mobileSubmenus.forEach(menu => {
            if (getComputedStyle(menu).getPropertyValue('max-height') != '0px') {
                menu.closest('li').classList.remove('open');
                menu.style.maxHeight = null;
            }
        });
        document.body.classList.remove('index--with-menu');
        
    }
});
const submenus = document.querySelectorAll('.submenu__links');

function showDefaultMenu() {
  
  const defaultMenu = document.querySelector('.submenu__links[data-link-index="default"]');
  if (defaultMenu.classList.contains('active')) {
    return;
  }
  submenus.forEach(submenu => {
    submenu.classList.remove('active');
  });
  defaultMenu.classList.add('active');
}

submenus.forEach(menu => {
  if (menu.getAttribute('data-link-index') !== 'default') {
    const linkIndex = menu.getAttribute('data-link-index');
    const link = document.querySelector(`.menu__item[data-link-index="${linkIndex}"]`);
    link.addEventListener('click', function(){
        const prevActiveEl = document.querySelector('.submenu__links.active');
        if(prevActiveEl === menu) {
          menu.classList.remove('active');
          showDefaultMenu();
          return;
        }
        if (prevActiveEl) {
            prevActiveEl.classList.remove('active');
        }
        menu.classList.add('active');
    })
  }
});

// Добавляем обработчик события для всего документа, чтобы скрывать меню при клике вне его
document.addEventListener('click', function(event) {
  
  const menuWrapper = document.querySelector('.menu__links');
  const closeButton = document.querySelector('.new-header-second__close');
  const isClickedButton = closeButton.contains(event.target);
  const isClickedInsideMenu = menuWrapper.contains(event.target);
  
  if (isClickedButton) {
    setTimeout(() => showDefaultMenu(), 1000);
  } else if (!isClickedInsideMenu) {
    showDefaultMenu();
  }
});




mobileSubmenus.forEach(menu => {
  const listItem = menu.closest('li');
  listItem.addEventListener('click', function(e) {
      
      const elementHeight = menu.scrollHeight;
      const isOpen = listItem.classList.contains('open');
      if (isOpen) {
          menu.style.maxHeight = '0';
      } else {
          menu.style.maxHeight = elementHeight + 'px';
      }
      listItem.classList.toggle('open');
  });
});

});